'use client';

import { usePrimeSupporterQuery } from './hooks/bundles';
import { primeSupporterQuery } from './queries';
export const DataPrimer = () => {
  usePrimeSupporterQuery(primeSupporterQuery);
  return null;
};